<template>
  <el-scrollbar>
    <label style="margin-left: 5px;font-weight: bold">员工信息:</label>
    <el-card style="margin: 5px">
      <el-form :model="employeeData" label-width="140px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="工号：" required>
              <el-input v-model="employeeData.employee_no" placeholder="工号"
                        oninput="value=value.replace(/[^\d]/g, '')" disabled clearable/>
            </el-form-item>
          </el-col>
<!--          <el-col :span="8" :offset="4">
            <el-button type="primary" plain style="width: 100px" @click="testMethod">定时任务测试</el-button>
          </el-col>-->
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-row>
              <el-col :span="24">
                <el-form-item label="姓名：" required>
                  <el-input v-model="employeeData.employee_name" placeholder="姓名" disabled clearable/>
                </el-form-item>
                <el-form-item label="职位：" required>
                  <el-select v-model="employeeData.position_id" placeholder="职位" clearable>
                    <el-option v-for="item in positionList" :key="item.id" :label="item.name"
                               :value="item.id"/>
                  </el-select>
                </el-form-item>
                <el-form-item label="职级类型：" required>
                  <el-select v-model="employeeData.level_type" placeholder="职级类型" clearable @change="getLevelList">
                    <el-option v-for="item in levelTypeList" :key="item.value" :label="item.label" :value="item.value"/>
                  </el-select>
                </el-form-item>
                <el-form-item label="职级：" required>
                  <el-select v-model="employeeData.position_level" placeholder="职级" clearable>
                    <el-option v-for="item in levelList" :key="item.level" :label="item.level" :value="item.level"/>
                  </el-select>
                </el-form-item>
                <el-form-item label="入职日期：" required>
                  <el-date-picker v-model="employeeData.entry_date" type="date" placeholder="选择日期"
                                  value-format="YYYY-MM-DD" style="width: 100%"/>
                </el-form-item>
                <el-form-item label="从业日期：" required>
                  <el-date-picker v-model="employeeData.start_work_date" type="date" placeholder="选择日期"
                                  value-format="YYYY-MM-DD" style="width: 100%"/>
                </el-form-item>
                <el-form-item label="手机号码：" required>
                  <el-input v-model="employeeData.phone" placeholder="手机号码"
                            oninput="value=value.replace(/[^\d]/g, '')" clearable/>
                </el-form-item>
                <el-form-item label="企业邮箱：">
                  <el-input v-model="employeeData.email" placeholder="企业邮箱" clearable/>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-form-item required>
              <kf-image-upload class="employee-photo" v-model="employeeData.photo" :init-file="employeeData.photo_obj"
                               @fileChange="photoChange" :limit="1"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="部门：" required>
              <el-cascader v-model="employeeData.department_ids" :options="departmentList"
                           :props="optionProps" :show-all-levels="true" style="width: 100%"/>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <label style="margin-left: 5px;font-weight: bold">试用期选项:</label>
    <el-card style="margin: 5px">
      <el-form :model="employeeData" class="demo-form-inline" label-width="150px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="试用期选项：">
              <el-switch v-model="employeeData.is_probation" @click="clearProbationEndDate"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="试用期结束日期：">
              <el-date-picker type="date" value-format="YYYY-MM-DD" v-model="employeeData.probation_end_date"
                              placeholder="选择日期" style="width: 100%" :disabled="!employeeData.is_probation" clearable/>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <el-row>
      <el-col :span="24" style="text-align: center">
        <el-button type="primary" :loading="loading" @click="saveEmployeeInfo">保存</el-button>
      </el-col>
    </el-row>
  </el-scrollbar>
</template>

<script>

import {Plus} from "@element-plus/icons-vue";
import axios from 'axios'

export default {
  name: "EmployeePhoto",
  components: {Plus},
  inject: ['$fn'],
  props: {
    componentParam: {
      type: String,
      required: true
    },
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  computed: {
    boolList() {
      return this.$store.getters['core/getDictList']('bool');
    }
  },
  data() {
    return {
      optionProps: {
        emitPath:false,
        value: 'id',
        label: 'name',
        checkStrictly:true,
        multiple: true,
      },
      photoUpload: {
        component: 'image_upload',
        limit: 1,
      },
      employeeData: {
        employee_no: '',
        employee_name: '',
        department_ids: [],
        position_ids: '',
        position_level: '',
        phone: '',
        email: '',
        photo: '',
        is_probation: false,
        probation_end_date: ''
      },
      dialogVisible: false,
      departmentList: [],
      positionList: [],
      levelTypeList:[],
      levelList: [],
      employeeTypeList: [],
      loading: false
    }
  },
  methods: {
    async loadEmployeeInfo() {
      let params = {id: this.parentData.id}
      let dbEmployee = await this.$http('employeeInfoService.getEmployeeInfo', params);
      if (dbEmployee) {
        this.employeeData = dbEmployee;
        if (this.employeeData.level_type == null && this.employeeData.level_type === ''){
          return;
        }
        let levelTypeParams = {levelType: this.employeeData.level_type}
        this.levelList = await this.$http('employeeHRService.getLevelList',levelTypeParams)
      }
    },
    //获取部门列表
    async getDepartmentList() {
      this.departmentList = await this.$http('sysUserDepartmentService.getDepartmentData');
    },
    //获取职位
    async getPosition() {
      let params = {type: "employee_position"}
      this.positionList = await this.$http('employeeHRService.getHrConfigListByType', params);
    },
    //获取职级类型
    async getLevelTypeList() {
      this.levelTypeList = await this.$http('employeeHRService.getLevelType')
    },
    //获取职级
    async getLevelList() {
      this.employeeData.position_level = ''
      if (this.employeeData.level_type == null && this.employeeData.level_type === ''){
        this.$message.error("请先选择职级类型");
        return;
      }
      let params = {levelType: this.employeeData.level_type}
      this.levelList = await this.$http('employeeHRService.getLevelList',params)

    },
    saveEmployeeInfo() {
      if (!this.employeeData.employee_no) {
        this.$message.error("请填写工号");
        return;
      }
      if (!this.employeeData.employee_name) {
        this.$message.error("请填写姓名");
        return;
      }
      if (!this.employeeData.position_id) {
        this.$message.error("请填写职位");
        return;
      }/*
      if (!this.employeeData.entry_date) {
        this.$message.error("请填写入职日期");
        return;
      }*/
      if (!this.employeeData.phone) {
        this.$message.error("请填手机号码");
        return;
      }
      if (this.employeeData.department_ids === null) {
        this.$message.error("请填写部门");
        return;
      }/*
      if (this.employeeData.position_level == null || this.employeeData.position_level === ''){
        this.$message.error("请选择职级");
        return;
      }
      if (!this.employeeData.photo) {
        this.$message.error("请上传照片");
        return;
      }*/
      let params = {
        id: this.parentData.id,
        employeeData: this.employeeData
      }
      this.loading = true;
      this.$http('employeeHRService.saveEmpInfo', params, false).then(() => {
        this.$message.success("保存成功");
        this.$fn.closeWindow();
        this.$fn.search();
        this.loading = false;
      }, errMsg => {
        this.$message.error(errMsg)
        // console.log(errMsg);//具体的message信息，等同⽤$axios时的error.message
        this.loading = false;
      })
    },
    //拍照
    async testMethod() {
      let params = {

      }
      this.$http('employeeContractService.checkAndUpdateContractStatus', params).then(() => {
        this.$message.success("定时任务测试成功");
      })
    },
    async photoChange(ids) {
      console.log(ids)
      if (ids.length <= 0) {
        this.employeeData.photo = ''
        return
      }
      this.employeeData.photo = ids[0];
    },
    clearProbationEndDate(){
      if (!this.employeeData.is_probation){
        this.employeeData.probation_end_date = ''
      }
    }
  },

  created() {
    this.getPosition();
    this.getLevelTypeList();
    // this.getJobLevel();
    this.getDepartmentList();
    this.loadEmployeeInfo();
  },
}
</script>

<style scoped lang="less">
.employee-photo {
  .el-upload-list--picture-card {
    --el-upload-list-picture-card-size: 260px;
  }

  .el-upload--picture-card {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width: 230px;
    height: 270px;
  }
}

.el-upload-list--picture-card {
  --el-upload-list-picture-card-size: 300px;
}

.el-upload--picture-card {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 300px;
  height: 300px;
}

.avatar {
  width: 300px;
  height: 300px;
  display: block;
}

.el-image {
  padding: 0 5px;
  max-width: 180px;
  max-height: 200px;
  width: 100%;
  height: 200px;
}

.image-slot {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background: var(--el-fill-color-light);
  color: var(--el-text-color-secondary);
  font-size: 30px;
}

.image-slot .el-icon {
  font-size: 30px;
}

.video-thumbnail {
  position: relative;
  display: inline-block;
}

.video-thumbnail::before {
  content: "";
  position: absolute;
  top: 5%;
  left: 30%;
  width: 320px; /* 根据需要调整方框的尺寸 */
  height: 400px; /* 根据需要调整方框的尺寸 */
  background-color: rgba(0, 0, 0, 0); /* 黑色半透明背景，根据需要调整 */
  border: 2px solid red; /* 白色边框，根据需要调整 */
  box-sizing: border-box; /* 边框计算在尺寸内 */
}
</style>